export default {
  title: 'WhatsApp template examples',
  subtitle:
    'You can edit any of the templates below and submit them for registration. Select the appropriate industry and message subject',
  searchPlaceholder: 'search by name or text',
  totalCount: 'Total examples – {{count}}',
  totalSearch: 'Examples by criteria – {{count}}',
  filters: {
    industry: 'Industry',
    topic: 'Message subject',
  },
  notFound: {
    title: "Sorry, we didn't find anything",
    subtitle: 'There are no templates with these parameters in the library yet',
    hint: 'Select other filters or create your own template',
    action: 'Create template',
  },
  registrationModal: {
    title: 'Example “{{name}}”',
    subTitle: "To change the contents of the template, click 'Edit template' and follow the steps",
    showExample: 'Show example',
    name: 'Template name',
    nameHint:
      'Enter a name consisting of letters, digits, and underscores (_). Do not use other characters or spaces.',
    subject: 'Register to this sender name (WhatsApp account)',
    wabaHint:
      'Facebook will register this template to your WhatsApp Business Account. When registered, the template will be available to all senders linked to this WABA: ',
    linkButton: 'Link button',
    linkButtonHint:
      'The button URL can be both static (fixed) and dynamic. If it is a dynamic URL, it must have two parts. The first one is a fixed (invariable) part (for example, a section of a website, like https://example.com/marketing/). ' +
      'The second, final part of the URL, can change for each broadcast created based on this template (for example, https://example.com/marketing/<b>action234</b> or https://example.com/marketing/<b>gift-1000</b>).\n' +
      'While setting up a broadcast, you can make a dynamic URL individual for each recepient of the broadcast if you add the required variable at the end of the URL. ',
    addUrl: 'Add button links',
    buttonText: 'Button text:',
    staticUrl: 'Static link (up to 2 000 characters)',
    dynamicUrl: 'Make the button URL dynamic',
    collectClicks: 'Track clicks on link buttons',
    collectClicksHint:
      'The link in the message is replaced individually for each recipient. The link expires 30 days after sending the message',
    phoneButton: 'Call button',
    addPhone: 'Add a phone number for the button',
    phone: 'Phone number with the plus sign and a country code, for example, +18001234567.',
    editButton: 'Edit template',
  },
  successModal: {
    title: 'The template has been submitted for registration',
    subtitle:
      'It may take several minutes to register such a template. Keep an eye on the status update of the template. You will be able to use it when sending broadcasts',
  },
  editModal: {
    title: 'Edit template?',
    subtitle:
      'You can change any parameters of the template, but then it should be submitted for review',
  },
};
